// Stable per-device identifier for break audit / device tracking.
export function deviceId() {
  let d = localStorage.getItem("vineops_device_id");
  if (!d) { d = crypto.randomUUID(); localStorage.setItem("vineops_device_id", d); }
  return d;
}
